export default () => {
  const headerLayout = document.querySelector(".layout__header");

  const getPageHeaderHeight = () => {
    if (headerLayout) return headerLayout.offsetHeight;
  };

  const getPageHeaderMainHeight = () => {
    const headerLayout = document.querySelector(
      ".layout__header .page-header-v1--main"
    );
    if (headerLayout) return headerLayout.offsetHeight;
  };

  const handleGlobalHeader = () => {
    const contextHeader = document.querySelectorAll(".layout__header-fixed");
    const mobileBreakpoint = window.matchMedia("(max-width: 959px)").matches;
    const isFixed = "is-fixed";

    var appBanner = document.querySelectorAll(".app-banner");
    var appBannerHeight = 0;

    if (appBanner.length) {
      var appBannerHeight = appBanner[0].clientHeight;
    }

    for (let i = 0; i < contextHeader.length; i++) {
      var context = contextHeader[i];
      var headerWrapper = context.querySelectorAll(".page-header-wrapper");
      var header = context.querySelectorAll(".page-header-v1--main");
      var headerTop = context.querySelectorAll(".page-header-v1--top");
      var headerTopHeight = headerTop[0].clientHeight;
      var headerTopOffset = headerTop[0].offsetTop;
    }

    if (contextHeader.length && headerTop.length) {
      if (header.length) {
        const addHeightHeader = () => {
          var headerHeight = header[0].clientHeight;
          headerWrapper[0].style.height = `${headerHeight}px`;
        };

        window.addEventListener("load", () => addHeightHeader());
        window.addEventListener("resize", () => addHeightHeader());
      }

      const headerFixed = () => {
        const offsetTop = window.pageYOffset;
        var headerOffset = headerTopOffset + headerTopHeight + appBannerHeight;

        if (offsetTop > headerOffset) {
          header[0].classList.add(isFixed);
        } else {
          header[0].classList.remove(isFixed);
        }
      };

      window.addEventListener("load", () => headerFixed());
      window.addEventListener("scroll", () => headerFixed());
    }
  };

  getPageHeaderMainHeight();
  handleGlobalHeader();
  window.addEventListener("resize", () => handleGlobalHeader());
};
